import { useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';

import { primitive } from 'styles/constants/primitives';

interface GreetingSectionProps {
  userName: string;
  currentPoints: number;
  displayedPoints: number;
}

export const GreetingSection = ({
  userName,
  currentPoints,
  displayedPoints,
}: GreetingSectionProps) => {
  const { formatMessage } = useIntl();

  return (
    <View style={styles.greetingSection}>
      <Text style={styles.greetingText}>
        {currentPoints > 0
          ? formatMessage(
              { id: 'niceWork', defaultMessage: `Nice work, {userName}! you've earned` },
              { userName }
            )
          : formatMessage(
              { id: 'letsGetStarted', defaultMessage: `Let's get started, {userName}!` },
              { userName }
            )}
      </Text>

      <Text style={styles.points}>{displayedPoints}</Text>

      <Text style={styles.pointsLabel}>
        {currentPoints > 0
          ? formatMessage({ id: 'availableCrowns', defaultMessage: 'Available Crowns' })
          : formatMessage({ id: 'crowns', defaultMessage: 'Crowns' })}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  greetingSection: { zIndex: 2, alignItems: 'center', marginBottom: 20 },
  greetingText: {
    lineHeight: 36,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: primitive.fontSizes.md,
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.bk.$bbqBrown,
  },
  points: {
    lineHeight: 36,
    fontSize: primitive.fontSizes['4xl'],
    fontFamily: primitive.fontFamily.$bold,
    color: primitive.bk.$bbqBrown,
  },
  pointsLabel: {
    lineHeight: 21,
    fontSize: primitive.fontSizes.sm,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.bk.$bbqBrown,
  },
});
